// client/src/components/wetakeover/TelegramSetup.jsx
import React from 'react';

const TelegramSetup = ({ telegramHandle, onHandleChange, orderId }) => {
  return (
    <div className="ui-motion-enter space-y-8 max-w-2xl mx-auto">
      <div className="text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-4">
          Almost <span className="text-yellow-300">Done!</span>
        </h2>
        <p className="text-white/70 text-lg">Share your Telegram Handle so we can coordinate with you directly</p>
      </div>

      {/* Success Indicator */}
      <div className="bg-gradient-to-r from-green-500/10 to-green-500/5 rounded-[32px] p-8 border border-green-500/20 text-center">
        <div className="w-20 h-20 rounded-full bg-green-500 flex items-center justify-center mx-auto mb-4">
          <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="text-2xl font-bold text-green-400 mb-2">Payment Confirmed!</div>
        <div className="text-white/70">Your campaign is being prepared</div>
      </div>

      {/* Order ID */}
      <div className="bg-white/5 rounded-[24px] p-6 border border-white/10">
        <div className="text-sm text-white/70 mb-2">Order ID</div>
        <div className="font-mono text-lg text-yellow-300">{orderId}</div>
      </div>

      {/* Telegram Input */}
      <div className="space-y-3">
        <label className="text-sm font-medium text-white/70">Telegram Handle</label>
        <div className="relative">
          <span className="absolute left-6 top-1/2 -translate-y-1/2 text-white/50">@</span>
          <input
            type="text"
            value={telegramHandle}
            onChange={(e) => onHandleChange(e.target.value.replace('@', ''))}
            placeholder="username"
            className="w-full bg-white/5 border border-white/10 rounded-[24px] py-4 pl-12 pr-6 text-white placeholder:text-white/30 focus:bg-white/10 focus:border-yellow-300 focus:outline-none transition-colors"
          />
        </div>
      </div>

      {/* Next Steps */}
      <div className="bg-white/5 rounded-[32px] p-8 border border-white/10 space-y-4">
        <h3 className="text-xl font-semibold text-yellow-300 mb-4">What Happens Next?</h3>

        <div className="space-y-4">
          <div className="flex gap-4">
            <div className="w-8 h-8 rounded-full bg-yellow-300 text-black flex items-center justify-center font-bold flex-shrink-0">
              1
            </div>
            <div>
              <div className="font-semibold mb-1">Campaign Setup</div>
              <div className="text-sm text-white/70">
                Based on your order we'll select the best suiting creators based on Cookieweb3 data.
              </div>
            </div>
          </div>

          <div className="flex gap-4">
            <div className="w-8 h-8 rounded-full bg-yellow-300 text-black flex items-center justify-center font-bold flex-shrink-0">
              2
            </div>
            <div>
              <div className="font-semibold mb-1">Telegram Group Set Up</div>
              <div className="text-sm text-white/70">
                We'll create a groupchat with you so we can have smooth communication during the campaign.
              </div>
            </div>
          </div>

          <div className="flex gap-4">
            <div className="w-8 h-8 rounded-full bg-yellow-300 text-black flex items-center justify-center font-bold flex-shrink-0">
              3
            </div>
            <div>
              <div className="font-semibold mb-1">Campaign Kickstart</div>
              <div className="text-sm text-white/70">
                Once your content goes live to QRT and we get a greenlight we kickstart the campaign.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Support */}
      <div className="bg-gradient-to-r from-yellow-300/10 to-yellow-300/5 rounded-[24px] p-6 border border-yellow-300/20">
        <div className="flex items-center gap-3">
          <div className="text-2xl">💬</div>
          <div>
            <div className="font-semibold mb-1">Need Help?</div>
            <div className="text-sm text-white/70">
              Questions? DM us on{' '}
              <a
                href="https://twitter.com/wetaborixyz"
                target="_blank"
                rel="noopener noreferrer"
                className="text-yellow-300 hover:text-yellow-400"
              >
                @wetaborixyz
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TelegramSetup;
